import { load } from "common/loader";
import { OnEvent } from "common/onEvent";
import { delay, delaySound } from "common/promises";
import { announcePaths, announceSoundPath } from "from-start/scene/resources";
import { loadSound, spritesDurations, } from "from-start/scene/resources/announceSound";
import log from "loglevel";
import { clickTicketEvent, moveNextClickEvent, nextButtonAppearEvent, } from "./announce";
export async function start() {
    let audioSrc = "";
    log.debug("announce load");
    while (true) {
        try {
            await load({
                onProgress: () => null,
                onComplete: () => null,
                onAudio: (src) => (audioSrc = src),
                filePaths: [...announcePaths, announceSoundPath],
            });
            break;
        }
        catch (e) {
            console.error(e);
            await delay(1000);
        }
    }
    let sound;
    while (true) {
        try {
            sound = await loadSound(audioSrc);
            break;
        }
        catch (e) {
            console.error(e);
            await delay(1000);
        }
    }
    const announce = $("<jh-announce></jh-announce>");
    $("#resizer").append(announce);
    await control(announce[0], sound);
    log.debug("remove announce");
    $("jh-announce").remove();
}
async function control(announce, sound) {
    log.debug("start announce control");
    sound.play("announceOpening");
    // 크루즈 탑승을 환영합니다. 2초 전에 끝낼 것
    await delaySound(Math.max(0, spritesDurations["announceOpening"] - 2500));
    sound.playLoop("announceBackground");
    sound.playLoop("buttonEffect");
    log.debug("show announce ticket");
    const onClick = new OnEvent({
        eventName: clickTicketEvent,
        selector: announce,
    });
    $(announce).attr("showTicket", "true");
    log.debug("announce wait user ticket click");
    await onClick.waitOnce();
    sound.stopLoop("buttonEffect");
    sound.stopLoop("announceBackground");
    log.debug("play video");
    $(announce).removeAttr("showTicket");
    $(announce).attr("showVideo", "true");
    const nextButtonAppear = new OnEvent({
        eventName: nextButtonAppearEvent,
        selector: announce,
    });
    const waitMoveNextClick = new OnEvent({
        eventName: moveNextClickEvent,
        selector: announce,
    });
    await nextButtonAppear.waitOnce();
    sound.playLoop("buttonEffect");
    log.debug("wait move next clicvk");
    await waitMoveNextClick.waitOnce();
    log.debug("move next clicked");
    sound.stopLoop("buttonEffect");
    log.debug("start fadeout");
    $(announce).removeAttr("showReady");
    $(announce).attr("fadeOut", "true");
    $(announce).find("video").animate({ volume: 0 }, 1000);
    await delay(1000);
}
//# sourceMappingURL=main.js.map